export default __webpack_public_path__ + "3637357d3e483a62dff80f38b1bf3502.png";